import { render, staticRenderFns } from "./table-cell-cmp.vue?vue&type=template&id=0195f67c&scoped=true"
import script from "./table-cell-cmp.vue?vue&type=script&lang=js"
export * from "./table-cell-cmp.vue?vue&type=script&lang=js"
import style0 from "./table-cell-cmp.vue?vue&type=style&index=0&id=0195f67c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0195f67c",
  null
  
)

export default component.exports